<template>
	<div class="content">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
		<div class="iot-management pa-content">
			<div class="container">
				<div class="row">
					<el-row>
						<el-col :xs="24" :md="12" class="iot-box wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h2 tips="智能柜解决方案">{{ langs.index9 }}</h2>
							<div class="iot-box-cont">
								<el-row>
									<el-col :xs="24" :md="8">
										<div class="iot-desc-img">
											<img src="../../static/images/iot/iot1.png" >
										</div>
									</el-col>
									<el-col :xs="24" :md="12">
										<div class="iot-desc">
											<h3>{{ langs.iot1 }}：</h3>
											<div>{{ langs.iot2 }}</div>
										</div>
										<router-link :to="{name: 'Iotdetail1'}" >
											<el-button round type="primary" class="to-detail">{{ langs.iot5 }}</el-button>
										</router-link>
										<!-- <el-button round type="primary" class="to-detail">查看详情</el-button> -->
									</el-col>
								</el-row>
							</div>
						</el-col>
						<el-col :xs="24" :md="12" class="iot-box wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h2>{{ langs.index11 }}</h2>
							<div class="iot-box-cont">
								<el-row>
									<el-col :xs="24" :md="8">
										<div class="iot-desc-img">
											<img src="../../static/images/iot/iot2.png" >
										</div>
									</el-col>
									<el-col :xs="24" :md="12">
										<div class="iot-desc">
											<h3>{{ langs.iot1 }}：</h3>
											<div>{{ langs.iot2 }}</div>
										</div>
										<router-link :to="{name: 'Iotdetail2'}" >
											<el-button round type="primary" class="to-detail">{{ langs.iot5 }}</el-button>
										</router-link>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :xs="24" :md="12" class="iot-box wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h2>{{ langs.index12 }}</h2>
							<div class="iot-box-cont">
								<el-row>
									<el-col :xs="24" :md="8">
										<div class="iot-desc-img">
											<img src="../../static/images/iot/iot3.png" >
										</div>
									</el-col>
									<el-col :xs="24" :md="12">
										<div class="iot-desc">
											<h3>{{ langs.iot1 }}：</h3>
											<div>{{ langs.iot2 }}</div>
										</div>
										<router-link :to="{name: 'Iotdetail3'}" >
											<el-button round type="primary" class="to-detail">{{ langs.iot5 }}</el-button>
										</router-link>
									</el-col>
								</el-row>
							</div>
						</el-col>
						<el-col :xs="24" :md="12" class="iot-box wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h2>{{ langs.iot3 }}</h2>
							<div class="iot-box-cont">
								<el-row>
									<el-col :xs="24" :md="8">
										<div class="iot-desc-img">
											<img src="../../static/images/iot/iot4.png">
										</div>
									</el-col>
									<el-col :xs="24" :md="12">
										<div class="iot-desc">
											<h3>{{ langs.iot1 }}：</h3>
											<div>{{ langs.iot2 }}</div>
										</div>
										<router-link :to="{name: 'Iotdetail4'}" >
											<el-button round type="primary" class="to-detail">{{ langs.iot5 }}</el-button>
										</router-link>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :xs="24" :md="12" class="iot-box wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h2>{{ langs.iot4 }}</h2>
							<div class="iot-box-cont">
								<el-row>
									<el-col :xs="24" :md="8">
										<div class="iot-desc-img">
											<img src="../../static/images/iot/iot5.png" >
										</div>
									</el-col>
									<el-col :xs="24" :md="12">
										<div class="iot-desc">
											<h3>{{ langs.iot1 }}：</h3>
											<div>{{ langs.iot2 }}</div>
										</div>
										<router-link :to="{name: 'Iotdetail5'}" >
											<el-button round type="primary" class="to-detail">{{ langs.iot5 }}</el-button>
										</router-link>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		data() {
			return {
				showLoading: true,
				
				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh,
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated） 
					offset: 0,//到元素距离触发动画（当默认为0） 
					mobile: true, //在移动设备上触发动画（默认为true） 
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init()
			})
			
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.iot-box{
		padding: 20px 0px 50px;
		cursor: pointer;
	}
	.iot-box h2{
		position: relative;
		font-size: 20px;
		/* background: linear-gradient(#d1ebf9,#c7eafc,#9fdef6,#5dc1f7,#95d6ef); */
		/* animation: bgttl 2s linear; */
	}
	@keyframes bgttl{
		0% {
		  transform: scaleX(0.4);
		  opacity: .8;
		}
		100% {
		  transform: scaleX(1);
		  opacity: 1;
		}
	}
	.iot-box h2::after{
		content: '';
		width: 20px;
		height: 3px;
		background-color: #409EFF;
		position: absolute;
		left: 0px;
		bottom: -5px;
	}
	.iot-desc-img{
		width: 180px;
		height: 180px;
		overflow: hidden;
		border-radius: 5px;
	}
	.iot-desc-img img{
		transition: 0.3s;
	}
	.iot-desc div{
		font-size: 15px;
		color: #999;
	}
	.iot-box:hover img{
		transform: scale(1.2);
	}
	@media screen and (max-width: 768px) {
		.iot-box{
			border-bottom: 1px solid #eee;
		}
		.iot-desc-img{
			display: block;
			margin: 0px auto;
		}
	}
	/* 查看详情 */
	.to-detail{
		padding: 8px 20px;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/iotIndex.vue